import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation, Link } from "react-router-dom"
import moment from "moment"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { Grid, Box, Typography, Tooltip, CircularProgress } from "@material-ui/core"
import AttachmentIcon from "../../../icons/AttachamentIcon"
import { operationsHelper } from "../../../../helpers/operations"
import { getFileRowClickRequest, getFileRequestByPage } from "../../../../actions/documentModalActions"
import { getAnnotation, getAuditHistory, updateViewerPageNumber, zoomInImage } from "../../../../actions/viewerActions"
import Annotations from "../../additionalDetails/Annotations"
import { ANNO_BG_COLOR } from "../../../../utils"
import { getReviewBasedOnFileIdRequest } from "../../../../actions/reviewActions"
import { searchHighlightFilter } from "../../../../actions/highlightActions"
import Modal from "@material-ui/core/Modal"
import Backdrop from "@material-ui/core/Backdrop"
import Fade from "@material-ui/core/Fade"
import Zoom from "@material-ui/core/Zoom"
import axios from "../../../../services/axios"

const useStyles = makeStyles((theme) => ({
	root: {
		...theme.typography.body2,
		backgroundColor: theme.palette.common.white,
		borderRadius: "5px",
		padding: "16px 23px",
		whiteSpace: "pre-line",
		maxHeight: "80vh",
		height: "65vh",
		overflow: "auto",
		display: "flex",
		textAlign: "center",
		justifyContent: "center",
	},
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		padding: "20px",
		margin: "20px",
		width: "65%",
		overflow: "hidden",
	},
}))

const AudioViewer = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const history = useHistory()
	const theme = useTheme()
	const [t] = useTranslation("global")
	const location = useLocation()
	const [open, setOpen] = useState(false)
	const [base64, setBase64] = useState(false)
	const handleOpen = () => setOpen(true)
	const handleClose = () => setOpen(false)
	const [base64Data, setBase64Data] = useState("")

	const { documentDetails, currentDocument } = useSelector((state) => state.documentModal)
	const highlightFilter = useSelector((state) => state.highlightFilter.search)
	const loadedConcept = useSelector((state) => state.highlightFilter.search.loadedConcept)
	const { imageZoomScale } = useSelector((state) => state.viewerData)
	useEffect(() => {
		const params = location?.pathname?.split("/")
		const fileId = params[params.length - 1]
		axios
			.get(`/file/download/${fileId}`, { responseType: "blob" })
			.then((response) => {
				if (response?.data) {
					const data = response.data
					const fileType = { type: "audio/mpeg" }
					const blob = new Blob([data], fileType)
					const url = URL.createObjectURL(blob)
					setBase64(url)
				} else {
					setBase64("...")
				}
			})
			.catch(() => {
				setBase64("...")
			})
	}, [])

	return (
		<Box className={classes.root} id="viewer-container">
			<Box onClick={handleOpen} style={{ cursor: "pointer", display: "flex", width: "100%", justifyContent: "center" }}>
				{base64 ? (
					<audio controls style={{ width: "100%" }}>
						<source src={base64} type="audio/ogg" />
						Your browser does not support the audio element.
					</audio>
				) : (
					<div
						style={{
							display: "flex",
							textAlign: "center",
							verticalAlign: "middle",
						}}
					>
						<div
							style={{
								alignItems: "center",
								display: "flex",
								justifyContent: "center",
							}}
						>
							<div
								style={{
									borderRadius: "0.25rem",
									padding: "0.5rem",
								}}
							>
								<CircularProgress />
							</div>
						</div>
						{documentDetails?.size >= 300000000 && (
							<div
								style={{
									alignItems: "center",
									display: "flex",

									justifyContent: "center",
								}}
							>
								<div
									style={{
										borderRadius: "0.25rem",
										padding: "0.5rem",
									}}
								>
									<div>{t("largerFile")}</div>
								</div>
							</div>
						)}
					</div>
				)}
			</Box>
		</Box>
	)
}

export default AudioViewer
